// @ts-ignore
import { htmlToText } from "html-to-text"

export function htmlToTextTransform(template?: string): string {
  if (template) {
    let text = htmlToText(`${template.trim()}`, {
      tags: {
        // @ts-ignore
        figure: { format: "skip" },
        img: { format: "skip" },
        a: { format: "skip" },
      },
    })

    text = text.replace(/(\r\n|\n|\r)/gi, " ")
    text = text.replace(/\u00A0/gi, " ")
    return text
  }

  return ""
}
